module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"no_item_message":{"none":"没有评论。","filtered":"没有符合条件的评论。"}}}')
  delete Component.options._Ctor
}
